import { useState } from "react";
import { toast } from "sonner";
import { inputCls, labelCls } from "./ShopUI";
import { customerLogin, customerRegister } from "../lib/api";
import { useShop } from "../context/ShopContext";

export const AuthForm = ({ heading, blurb }) => {
  const { signIn } = useShop();
  const [mode, setMode] = useState("register");
  const [form, setForm] = useState({ name: "", email: "", password: "", phone: "" });
  const [busy, setBusy] = useState(false);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    if (mode === "register" && form.password.length < 8) {
      return toast.error("Please use a password of at least 8 characters.");
    }
    setBusy(true);
    try {
      const { data } =
        mode === "register"
          ? await customerRegister(form)
          : await customerLogin(form.email, form.password);
      signIn(data.token, data.customer);
      toast.success(mode === "register" ? "Account created." : `Welcome back, ${data.customer.name || ""}.`);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Something went wrong. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="border border-cream-border bg-[#fbf8f1] p-8 md:p-10" data-testid="auth-form">
      <h2 className="font-serif text-2xl md:text-3xl text-ink">{heading}</h2>
      {blurb && <p className="text-sm text-ink-muted mt-3 leading-relaxed">{blurb}</p>}

      <div className="flex gap-6 mt-7 border-b border-cream-border">
        {[["register", "Create account"], ["login", "I have an account"]].map(([id, label]) => (
          <button key={id} onClick={() => setMode(id)} data-testid={`auth-tab-${id}`}
            className={`pb-3 text-xs uppercase tracking-[0.18em] border-b-2 -mb-px transition-colors ${mode === id ? "border-gold text-gold" : "border-transparent text-ink-muted hover:text-ink"}`}>
            {label}
          </button>
        ))}
      </div>

      <form onSubmit={submit} className="space-y-5 mt-7">
        {mode === "register" && (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            <div>
              <label className={labelCls}>Full name</label>
              <input className={inputCls} value={form.name} onChange={(e) => set("name", e.target.value)} required data-testid="auth-name" />
            </div>
            <div>
              <label className={labelCls}>Phone (optional)</label>
              <input className={inputCls} value={form.phone} onChange={(e) => set("phone", e.target.value)} data-testid="auth-phone" />
            </div>
          </div>
        )}
        <div>
          <label className={labelCls}>Email</label>
          <input type="email" className={inputCls} value={form.email} onChange={(e) => set("email", e.target.value)} required data-testid="auth-email" />
        </div>
        <div>
          <label className={labelCls}>Password</label>
          <input type="password" className={inputCls} value={form.password} onChange={(e) => set("password", e.target.value)} required data-testid="auth-password" />
          {mode === "register" && <p className="text-[0.65rem] text-ink-muted mt-2">Minimum 8 characters.</p>}
        </div>
        <button type="submit" disabled={busy} data-testid="auth-submit"
          className="w-full px-8 py-4 bg-[#221d17] text-cream text-xs font-semibold uppercase tracking-[0.2em] hover:bg-black transition-colors disabled:opacity-60">
          {busy ? "Please wait…" : mode === "register" ? "Create account" : "Sign in"}
        </button>
      </form>
    </div>
  );
};
